// extracted by mini-css-extract-plugin
module.exports = {"block":"SpinnerBlock_block__EJaiK"};